import { render } from "./RequestPricingCard.vue?vue&type=template&id=06820e15"
import script from "./RequestPricingCard.vue?vue&type=script&lang=js"
export * from "./RequestPricingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__